// NATIVE
import React, { useEffect, useState } from 'react';

// INSTALLED
import { useFormikContext } from 'formik';
import Divider from '@mui/material/Divider';
import { Button, Card, CardActionArea, CardMedia, Grid } from '@mui/material';

// CUSTOM
import { useDispatch } from 'react-redux';
import { UploadButtonField } from '../../formFields/uploadButtonField';
import { uploadImgStore } from '../../../store/uploaders';
import { LinearProgressWithLabel } from '../../LinearProgressWithLabel';

export const LogosRazonSocial = (props: any) => {
  const dispatch = useDispatch();

  const [percentage_rz_upload_logo, setPercentageRzUploadLogo] = useState(0);
  const [file_logo_comercial, setFileRzLogo] = useState(null);
  const [preview_rz_logo, setPreviewRzLogo] = useState('');
  const [file_n_rz_name, setLogoRzFileName] = useState('');

  const [percentage_rz_upload_post, setPercentageRzUploadPost] = useState(0);
  const [file_logo_post, setFileRzPost] = useState(null);
  const [preview_rz_post, setPreviewRzPost] = useState('');
  const [file_post_name, setPostFileName] = useState('');

  const {
    formField: { logo_company, logo_post_company },
  } = props;

  const formikProps: any = useFormikContext();

  // VERIFICA QUE SI ESTA DEFINIDO EN EL FORMIK LOS LOGOS LOS PONE
  // PORQUE EL STEPER LO BORRA AL VOLVER
  useEffect(() => {
    if (formikProps.values.logo_company) {
      const objectURL = URL.createObjectURL(formikProps.values.logo_company);
      setPreviewRzLogo(objectURL);
      setPercentageRzUploadLogo(100);
    }

    if (formikProps.values.logo_post_company) {
      const objectURL = URL.createObjectURL(formikProps.values.logo_post_company);
      setPreviewRzPost(objectURL);
      setPercentageRzUploadPost(100);
    }
  }, []);

  const uploadFileLogo = async ({ target }: any) => {
    const { name } = target.files[0];
    setLogoRzFileName(name);
    setFileRzLogo(target.files[0]);

    const objectURL = URL.createObjectURL(target.files[0]);
    setPreviewRzLogo(objectURL);

    formikProps.setFieldValue('logo_company', target.files[0]);
    const { ok, data } = await dispatch(
      uploadImgStore('image-company', target.files[0], setPercentageRzUploadLogo)
    );

    if (ok) {
      formikProps.setFieldValue('logo_bn_rz_company_name_saved_file', data.imgName);
    }
  };

  const uploadFileLogoPost = async ({ target }: any) => {
    const { name } = target.files[0];
    setPostFileName(name);
    setFileRzPost(target.files[0]);

    const objectURL = URL.createObjectURL(target.files[0]);
    setPreviewRzPost(objectURL);

    formikProps.setFieldValue('logo_post_company', target.files[0]);
    const { ok, data } = await dispatch(
      uploadImgStore('image-company', target.files[0], setPercentageRzUploadPost)
    );
    if (ok) {
      formikProps.setFieldValue('logo_bn_rz_post_company_name_saved_file', data.imgName);
    }
  };

  return (
    <div>
      <Grid container spacing={2}>
        <Grid size={{ xs: 6 }}>
          <Button> Sube Tu Logo Razon Social</Button>
          <Divider />
          <UploadButtonField
            onChange={uploadFileLogo}
            accept={'image/*'}
            name={logo_company.name}
            label={logo_company.label}
            text={'Subir Archivo'}
          />
          {formikProps.values.logo_company ? (
            <>
              <Card sx={{ maxWidth: 345, marginTop: 7 }}>
                <CardActionArea>
                  <CardMedia
                    component="img"
                    height="140"
                    sx={{ objectFit: 'contain' }}
                    image={preview_rz_logo}
                    alt="green iguana"
                  />
                </CardActionArea>
              </Card>
              <Card variant="elevation" sx={{ marginTop: 1.5, padding: 1, height: '70%' }}>
                <LinearProgressWithLabel
                  percentage={percentage_rz_upload_logo}
                  label={formikProps.values.logo_company.name}
                  hasIcon={false}
                />
              </Card>
            </>
          ) : (
            ''
          )}
        </Grid>
        <Grid size={{ xs: 6 }}>
          <Button> Sube Tu Logo Post Razon Social</Button>
          <Divider />
          <UploadButtonField
            onChange={uploadFileLogoPost}
            accept={'image/*'}
            name={logo_post_company.name}
            label={logo_post_company.label}
            text={'Subir Archivo'}
          />

          {formikProps.values.logo_post_company ? (
            <>
              <Card sx={{ maxWidth: 345, marginTop: 7 }}>
                <CardActionArea>
                  <CardMedia
                    component="img"
                    height="140"
                    sx={{ objectFit: 'contain' }}
                    image={preview_rz_post}
                    alt="green iguana"
                  />
                </CardActionArea>
              </Card>
              <Card variant="elevation" sx={{ marginTop: 1.5, padding: 1, height: '70%' }}>
                <LinearProgressWithLabel
                  percentage={percentage_rz_upload_post}
                  label={formikProps.values.logo_post_company.name}
                  hasIcon={false}
                />
              </Card>
            </>
          ) : (
            ''
          )}
        </Grid>
      </Grid>
    </div>
  );
};
